import { defineComponent as _defineComponent } from 'vue'
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import CardContentLoader from '@/components/card-content-loader.vue';
import { language, CustomException } from '@tencent/ppd-base-libs';
import {
  HelpFriend,
  HelpStatusDialog,
  ShareCouponLarge,
  getShareInfoBySpId,
  getHelpInfo,
  ActivityStatus,
} from '@tencent/wphk-components-help-friend';
import { ref } from 'vue';
import { useWxShare } from '@/hooks/use-wx-share';
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import { useDialogManager } from '@/hooks/use-dialog-manager';
import { SHARE_COUPON_DIALOG } from '@/config/dialog-manager-config';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { useMerchantInfo } from '../../../store/merchant-info-module';
import { ModuleName } from '@/types/module-config';
import { mittBus, MITT_TYPES } from '@/business/mitt-bus';
import { getShareCouponShowInfo } from './business';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['initDone'],
  setup(__props, { emit }) {

const { getBiExt } = useGlobalBi();

const isEn = language.isEn();

const helpFriendDialog = ref<InstanceType<typeof HelpFriend> | null>(null);
const helpStatusDialog = ref<InstanceType<typeof HelpStatusDialog> | null>(null);
/** 分享券信息 */
const shareCouponInfo = ref();
const shareSpId = ref('');

const isReady = ref(false);
const isShow = ref(true);
const isNeedInit = ref(false);

/** 是否是注册后的关闭 */
const isFirstClose = ref(false);
/** 状态弹窗是否打开了助力弹窗 */
const isShowSecondDialog = ref(false);

const { showWithDialogManager, hideWithDialogManager } = useDialogManager();
const onShowDialog = showWithDialogManager(SHARE_COUPON_DIALOG, () => {
  console.log('====注册&打开弹窗');
  isFirstClose.value = true;
  handleShowDialog();
});
const onHideDialog = hideWithDialogManager(SHARE_COUPON_DIALOG, () => {
  console.log('====关闭弹窗');
  isFirstClose.value = false;
  isShowSecondDialog.value = false;
});

const onBeforeHideDialog = (isShow: boolean) => {
  // 状态弹窗关闭会调佣两次，需要判断是不是又打开了另一个弹窗
  if (isShowSecondDialog.value) {
    return;
  }
  if (isShow) {
    isShowSecondDialog.value = true;
    openHelpFriendDialog();
    return;
  }
  if (isFirstClose.value) {
    onHideDialog();
  }
};
const onBeforeHideDialog2 = () => {
  if (isFirstClose.value) {
    onHideDialog();
  }
};

// 券面按钮点击
const openHelpFriendDialog = (isSameUser = true) => {
  helpFriendDialog.value?.showHelpFriendDialog(shareCouponInfo.value.couponId, isSameUser);
};
// 重置微信分享内容
const resetWxShare = () => {
  const { setCommonShareInfo } = useWxShare();
  setCommonShareInfo();
};
/**
 * 处理展示哪个弹窗
 * 1. 如果是本人的分享码 or 需要开启助力弹窗（除了已结束 已派完 好友已集齐 已助力外，即可以给好友助力时） =》 打开助力弹窗
 * 2. 否则打开券状态弹窗
 */
const handleShowDialog = async () => {
  const shareCouponCode = getUrlParamByKey(UrlParamKey.shareCouponCode);
  // 如果没有分享码，则什么都不做
  if (!shareCouponCode) return;
  const data = await getHelpInfo({ actId: shareCouponInfo.value.actId, shareCode: shareCouponCode });
  // 如果是本人的分享码
  if (data.isSameUser) {
    openHelpFriendDialog(true);
    return;
  }
  // 如果可以给好友助力
  if (data.status === ActivityStatus.open) {
    openHelpFriendDialog(false);
    return;
  }
  // 展示获取助力状态
  helpStatusDialog.value?.showDialog({
    status: data.status,
    couponName: shareCouponInfo.value.couponInfo.couponName,
    couponId: shareCouponInfo.value.couponInfo.couponId,
  });
};
// 助力组件加载完成后
const onInited = async (isAfterHighAuth: boolean) => {
  await init();
  // 如果是高授权回来，则不重复拉起
  if (isAfterHighAuth) {
    emit('initDone', { moduleName: ModuleName.ShareCouponModule });
    return;
  }
  // 处理好友分享助力状态弹窗(活动 id+好友分享码)
  onShowDialog();
  emit('initDone', { moduleName: ModuleName.ShareCouponModule });
};

// 注册事件
mittBus.on(MITT_TYPES.bannerShareCouponClick, (value) => {
  if (!isNeedInit.value) {
    new CustomException('', 'bannerShareCouponClickErr', '产品配置问题，投放中台banner配置了分享券，但是分享券没有初始化（分享券配置没有找到）');
    return;
  }
  if (isReady.value) {
    openHelpFriendDialog();
  }
});

const init = async () => {
  try {
    // 获取商户品牌页商户 ID
    const { spId: merchantSpId } = useMerchantInfo();
    if (!merchantSpId) {
      throw new Error('商户品牌页商户 ID 为空');
    }
    // 获取分享券展示信息
    const { isNeedInit: isNeedInitShareCoupon, isNeedShow, spId = '', shareSpId: shareCouponShareSpId = '' } = await getShareCouponShowInfo(merchantSpId);
    shareSpId.value = shareCouponShareSpId;
    isNeedInit.value = isNeedInitShareCoupon;
    isShow.value = isNeedShow;
    // 初始化分享券
    if (isNeedInit.value && spId) {
      shareCouponInfo.value = await getShareInfoBySpId(spId);
    };
    isReady.value = true;
  } catch (error) {
    isReady.value = true;
    isShow.value = false;
  }
};

return { __sfc: true,getBiExt, emit, isEn, helpFriendDialog, helpStatusDialog, shareCouponInfo, shareSpId, isReady, isShow, isNeedInit, isFirstClose, isShowSecondDialog, showWithDialogManager, hideWithDialogManager, onShowDialog, onHideDialog, onBeforeHideDialog, onBeforeHideDialog2, openHelpFriendDialog, resetWxShare, handleShowDialog, onInited, init, BaseComponent, CardContentLoader, HelpFriend, HelpStatusDialog, ShareCouponLarge }
}

})